<template>
    <div class="login-page-wrapper flex h-100vh">
        <div class="absolute z-99 top-20px left-20px flex justify-between w-full">
            <GoBack :go="goHome" class="invisible" />
            <Locale class="mr-40px" />
        </div>
        <div class="w-58.25% bg-[rgba(255,255,255,0.05)] h-full flex-center flex-col">
            <img :src="logo" class="mb-100px cursor-pointer" @click="goHome" />
            <div class="w-645px text-[var(--text-color)]">
                <!-- <p class="text-16 font-600 mb-8">Current Limitations:</p> -->
                <!-- <p>
                    Due to limited computational resources, we currently allow only a limited number of predictions per user, and the server is
                    optimized for relatively short proteins. Support for longer sequences and more complex systems will be added in future updates.
                </p> -->
                <!-- <ImageVideoLoading
                    src="https://baai-solution.ks3-cn-beijing.ksyuncs.com/emu3/static/video_generation/A%20squirrel%20eating%20a%20burger..mp4"
                    isNotAutoPause
                    isAutoPlay
                    type="video"
                    :isShowBoxShdow="false"
                    class="!rounded-8px !h-366px"
                /> -->
            </div>
        </div>
        <div class="flex-1 flex-center flex-col min-w-600px bg-[rgba(1,3,20,0.01)]">
            <phone @after-login="afterLogin" />
            <div class="mt-32px w-317px line-height-22px">
                <!-- <p class="text-secondColor">{{ t('login.tipTitle') }}</p> -->
                <!-- <div class="text-[var(--text-color)] text-12 break-all">
                    {{ t('common.tip1') }}
                    <p>
                        <span @click="openContent(DialogContentType.SERVICE_AGREEMENT)" class="text-[var(--a-link-color)] cursor-pointer">
                            {{ t('common.agreement1') }}
                        </span>
                        ,
                        <span @click="openContent(DialogContentType.PROHIBITED_CONDUCT)" class="text-[var(--a-link-color)] cursor-pointer">
                            {{ t('common.agreement2') }}
                        </span>
                        <span>&nbsp;{{ t('common.and') }}&nbsp;</span>
                        <span @click="openContent(DialogContentType.PRIVACY)" class="text-[var(--a-link-color)] cursor-pointer">
                            {{ t('common.agreement3') }}
                        </span>
                        .
                    </p>
                </div> -->
            </div>
        </div>
    </div>
    <!-- <protocol v-model:dialogVisible="dialogVisible" :visibleAgreeBtn="false"></protocol> -->
    <DialogInformation :type="type" @close="() => (type = undefined)" />
</template>

<script lang="ts" setup>
import logo from '@/assets/imgs/logo2.png';
import phone from './components/phone.vue';
import DialogInformation from '@/views/ServiceAgreement/components/DialogInformation.vue';
import ImageVideoLoading from '@/components/ImageVideoLoading.vue';
import { Message } from '@/utils/message';
import { DialogContentType } from '../ServiceAgreement/config';
import { useI18n } from 'vue-i18n';
import Locale from '@/layout/components/Locale.vue';
import 'flag-icons/css/flag-icons.min.css';
const { t } = useI18n();
const type = ref();
const { push } = useRouter();
const openContent = (contentType: DialogContentType) => {
    type.value = contentType;
};
// 协议 start
const router = useRouter();
const { setUserInfo } = useStore('user');
const afterLogin = (userInfo: any) => {
    Message.success(t('login.successTip1'), 1000);
    setTimeout(() => {
        router.push('/');
    }, 1000);
};
const goHome = () => {
    // if (isOpenPublicBetaPage()) {
    //     return;
    // }
    // push('/home');
};
</script>
<style lang="scss" scoped>
.login-page-wrapper {
    font-family: Roboto, Roboto;
    // background: linear-gradient(180deg, #001547 0%, #000b25 100%);
    // background-color: #0e0e0f;
}

:deep(.el-tabs) {
    --el-border-color-light: transparent;
    --el-tabs-header-height: 42px;
    .el-tabs__active-bar.is-top {
        margin-left: 60px;
    }
    .el-tabs__content {
        display: flex;
        justify-content: center;
    }
    --el-text-color-primary: #999;
    --el-text-color-regular: #999;
}
</style>
